module.exports = __webpack_public_path__ + "static/banner-b8a64c6463b2e02f06f620356aa1c042.jpg";